import { inject, Injectable } from '@angular/core';
import { getFirstChildRouteDataArray, getFullRoute, getMobileRoute } from '@app/shared/utils/route-utils';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SetActiveMediaQueries } from '../actions/media.actions';
import { Go } from '../actions/router.actions';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class MediaEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  setActiveMediaQueries$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SetActiveMediaQueries),
      map(action => action.activeMediaQueries),
      switchMap((activeMediaQueries) => {
        const routeSnapshot = this.route.snapshot;

        const routeData = getFirstChildRouteDataArray(routeSnapshot);

        if (activeMediaQueries.includes('lt-md')) {
          if (routeData.some(routeDatum => routeDatum.mobilePath != null)) {
            return of(Go({path: getMobileRoute(routeSnapshot)}));
          }
        } else {
          if (routeData.some(routeDatum => routeDatum.fullPath != null)) {
            return of(Go({path: getFullRoute(routeSnapshot)}));
          }
        }
        return EMPTY;
      }),
    );
  });
}
